var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import Model from 'models/Model';
import ReceptionDesk from './ReceptionDesk';
import Specialization from './Specialization';
var ClinicRoom = /** @class */ (function (_super) {
    __extends(ClinicRoom, _super);
    function ClinicRoom() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClinicRoom.prototype.getId = function () {
        return Number(this.id);
    };
    ClinicRoom.prototype.getName = function () {
        return this.name;
    };
    ClinicRoom.prototype.setName = function (name) {
        this.name = name;
    };
    ClinicRoom.prototype.getCode = function () {
        return this.code || '';
    };
    ClinicRoom.prototype.setCode = function (code) {
        this.code = code;
    };
    ClinicRoom.prototype.isActive = function () {
        return this.active !== false;
    };
    ClinicRoom.prototype.setActive = function (active) {
        this.active = active;
    };
    ClinicRoom.prototype.getReceptionDeskId = function () {
        var _a, _b;
        var value = Number((_a = this.reception_desk_id) !== null && _a !== void 0 ? _a : (_b = this.getReceptionDesk()) === null || _b === void 0 ? void 0 : _b.getId());
        return Number.isNaN(value) ? 0 : value;
    };
    ClinicRoom.prototype.setReceptionDeskId = function (receptionDeskId) {
        this.reception_desk_id = receptionDeskId;
    };
    ClinicRoom.prototype.getSpecializationId = function () {
        var _a, _b;
        var value = Number((_a = this.specialization_id) !== null && _a !== void 0 ? _a : (_b = this.getSpecialization()) === null || _b === void 0 ? void 0 : _b.getId());
        return Number.isNaN(value) ? 0 : value;
    };
    ClinicRoom.prototype.setSpecializationId = function (specializationId) {
        this.specialization_id = specializationId;
    };
    ClinicRoom.prototype.getReceptionDesk = function () {
        return this.reception_desk
            ? plainToClass(ReceptionDesk, this.reception_desk)
            : undefined;
    };
    ClinicRoom.prototype.getSpecialization = function () {
        return this.specialization
            ? plainToClass(Specialization, this.specialization)
            : undefined;
    };
    return ClinicRoom;
}(Model));
export default ClinicRoom;
